import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PaymentContext, usePaymnetContext } from "../..";
import { getTransactionStatusAPI } from "../apiSercive";
import { getQueryStringValue, PREVIEW_MODE } from "../common";
import InformationCard from "../Information.card/InformationCard";
import { AppHeader } from "../payment.checkout";

const PaymentStatus = () => {
    const { state, update } = usePaymnetContext();
    const { t } = useTranslation();

    const fetchStatus = () => {
        const id = getQueryStringValue("id");
        const provider = getQueryStringValue("provider");
        getTransactionStatusAPI(id, provider).then((response: any) => {
            // if (response.success) {
            update({
                ...state,
                status: response.data?.toLowerCase(),
                statusAttempt: state.statusAttempt + 1
            })
            // } else {
            //     //what should i need to do
            // }
        }).catch((error: any) => {
            update({
                ...state,
                success: false,
                systemMessage: {
                    ...state.systemMessage,
                    show: true,
                    title: error?.code,
                    message: error.message
                }
            });
        });
    }

    useEffect(() => {
        if (state.mode === PREVIEW_MODE || getQueryStringValue("id") === PREVIEW_MODE) {
            update({
                ...state,
                status: "success",
            });
            return;
        }
        let redirectTimer: any = undefined;
        const timer = setInterval(() => {
            console.log(state.statusAttempt)
            if (state.status === "pending" && state.statusAttempt < 4) {
                fetchStatus()
            }
        }, 10000);


        return () => {
            clearInterval(timer);
            clearTimeout(redirectTimer);
        }
    }, [state.statusAttempt]);

    useEffect(() => {
        let successTimer: any = undefined;
        let failureTimer: any = undefined;
        if (paymentDetails?.redirectSuccessURL && state.status === "success") {
            successTimer = setTimeout(() => {
                window.location.href = paymentDetails?.redirectSuccessURL;
            }, 3000);
        } else if (paymentDetails?.redirectFailURL && state.status === "failed") {
            failureTimer = setTimeout(() => {
                window.location.href = paymentDetails?.redirectFailURL;
            }, 3000);

        }

        return () => {
            clearTimeout(successTimer);
            clearTimeout(failureTimer);
        };
    }, [state.status])
    const paymentDetails = JSON.parse(localStorage.getItem("pgvnext:paymentDetails") || "{}");
    const getFallbackURL = () => {
        // if (state.status === "success") {
        //     return paymentDetails?.redirectSuccessURL;
        // }
        if (state.status === "pending" && state.statusAttempt > 3) {
            return paymentDetails?.redirectFailURL;
        }
    }

    return <section className="payment-checkout-page">
        <AppHeader />
        <InformationCard
            title={state.status === "success" ? t("hooray") : ""}
            title2={t(`${state.status}Payment`)}
            loading={state.status === "pending"}
            desc={getQueryStringValue("id") === PREVIEW_MODE ? t(`${state.status}PaymentDetail`) : t("confirmationMsg", { vendorName: paymentDetails.vendorName || paymentDetails.appName, format: paymentDetails.currency, value: t("intlNumber", { val: paymentDetails.amount, locale: paymentDetails.currency }) })}
            redirectText={t("goBack")}
            redirectURL={getFallbackURL()}
        />
    </section>
}

export default PaymentStatus;